import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getRegistrations = async (id) => {
  const response = await axios.get(routes.inviteflowRegistrations(id), AXIOS_DEFAULT_CONFIG);
  return response;
};

export default getRegistrations;
